import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {ChannelSelector} from "../buttons/ChannelSelector.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";

const useTools = () => {
    // Read-only module (FNP-535): no Add/Delete. The list is per-channel (the GSI
    // partition key is required), so the channel selector stands in for a filter;
    // plus Reload.
    const tools = [];

    tools.push(<ChannelSelector key='channel'/>);
    tools.push(<ReloadRecordsButton key='reload'/>);

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Reconciliation Reports')}
            tools={useTools()}
        />
    );
};
